/* eslint-disable @typescript-eslint/ban-ts-comment */
import BookIcon from "@app/icons/dashboard/book";
import UserIcon from "@app/icons/dashboard/user";
import UserPaymentIcon from "@app/icons/dashboard/user-payment";
import UserNewIcon from "@app/icons/dashboard/user-new";
import AuthorIcon from "@app/icons/dashboard/author";
import clsx from "clsx";
import { memo, useEffect, useState } from "react";
import {
  GeneralInformationItem,
  GeneralInformation as GeneralInformationType,
} from "@app/types/dashboard.type";
import DashboardService from "@app/services/http/dashboard.service";
import { StatisticsState } from "@app/types";
import { openPortalDialog } from "@app/services/modal.service";
import GeneralInformationDashboardModal from "@app/components/general-information-dashboard-modal";

interface ItemsType {
  label: string;
  key: string;
  icon: any;
  classBackground: string;
  keyChild?: string;
}

const Items: ItemsType[] = [
  {
    label: "Số lượng sách",
    key: "totalBook",
    icon: BookIcon,
    classBackground: "bg-[#5570F1]",
    keyChild: "infoBooks",
  },
  {
    label: "Số lượng user",
    key: "totalUser",
    icon: UserIcon,
    classBackground: "bg-[#771BCC]",
    keyChild: "infoUsers",
  },
  {
    label: "Số user thanh toán",
    key: "totalUserPurchase",
    icon: UserPaymentIcon,
    classBackground: "bg-[#FFAB00]",
    keyChild: "infoRevenues",
  },
  {
    label: "Số user mới",
    key: "totalUserNew",
    icon: UserNewIcon,
    classBackground: "bg-[#71DD37]",
  },
  {
    label: "Số lượng tác giả",
    key: "totalAuthor",
    icon: AuthorIcon,
    classBackground: "bg-[#FF3E1D]",
  },
];

const GeneralInformation = ({ filter }: { filter: StatisticsState }) => {
  const [data, setData] = useState<GeneralInformationType>();

  useEffect(() => {
    DashboardService.getGeneralInformation({
      startDate: filter.startDate || undefined,
      endDate: filter.endDate || undefined,
    }).then((res) => {
      setData(res.data);
    });
  }, [filter.startDate, filter.endDate]);

  const handleShowPopup = (item: ItemsType) => {
    if (!item.keyChild) return;

    const dataPopup =
      data?.[item.keyChild as keyof GeneralInformationType] ?? [];

    openPortalDialog(GeneralInformationDashboardModal, {
      data: dataPopup as GeneralInformationItem[],
      icon: item.icon,
    });
  };

  return (
    <div className="text-white flex flex-wrap justify-start gap-[24px]">
      {Items.map((item, index) => (
        <div
          key={index}
          className={clsx(
            "w-[193px] h-[140px] rounded-[12px] flex flex-col gap-4 p-[24px]",
            item.classBackground,
            {
              "cursor-pointer": !!item.keyChild,
            }
          )}
          onClick={() => handleShowPopup(item)}
        >
          <div className="flex gap-4 items-center">
            <div className="w-[40px] h-[40px] bg-[#FFFFFF] bg-opacity-20 rounded-[8px] flex items-center justify-center">
              <item.icon />
            </div>
            <p className="text-[24px] font-medium">
              {/* @ts-expect-error */}
              {data?.[item.key as keyof GeneralInformationType] ?? 0}
            </p>
          </div>
          <p className="text-[14px]">{item.label}</p>
        </div>
      ))}
    </div>
  );
};

export default memo(GeneralInformation);
